import { useState } from 'react';
import { tr } from '../../lib/i18n';
import { Inp, _inp } from './Inputs.jsx';

/** Valeur de la ligne « Autre… », qui ouvre la saisie libre. */
const AUTRE = '__autre__';

/**
 * Unité d'une ligne : un choix qui s'ouvre au toucher, avec les unités de
 * l'entreprise (Réglages → Mon activité). Les pastilles mm, cm, m… alignées
 * sous le champ encombraient la ligne ; « Autre… » garde la saisie libre pour
 * une unité qui n'est pas dans la liste.
 *
 * @param {object} props propriétés du composant
 * @param {string} [props.label] libellé du champ
 * @param {string} props.value unité de la ligne
 * @param {(u: string) => void} props.onChange reçoit l'unité choisie
 * @param {string[]} props.unites unités proposées
 * @param {string} [props.placeholder] exemple de la saisie libre
 * @returns {import('react').ReactElement} le champ
 */
export function ChampUnite({ label = 'Unité', value, onChange, unites, placeholder }) {
  const [libre, setLibre] = useState(false);
  const v = value || '';
  if (libre) {
    return (
      <Inp
        label={label}
        value={v}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
  // Une unité saisie à la main reste dans la liste, choisie.
  const liste = v && !unites.includes(v) ? [...unites, v] : unites;
  return (
    <Inp label={label}>
      <select
        aria-label={tr(label)}
        value={v}
        onChange={(e) => (e.target.value === AUTRE ? setLibre(true) : onChange(e.target.value))}
        style={{ ..._inp, padding: '10px 8px', appearance: 'auto' }}
      >
        {!v && <option value="">—</option>}
        {liste.map((u) => (
          <option key={u} value={u}>
            {u}
          </option>
        ))}
        <option value={AUTRE}>{tr('✎ Autre…')}</option>
      </select>
    </Inp>
  );
}
